import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { formatCurrencyInput } from '../../../utils/currencyFormatter';

const TaxSection = ({ formData, errors, onChange }) => {
  const handleCurrencyInputChange = (field, rawValue) => {
    const formatted = formatCurrencyInput(rawValue);
    onChange(field, formatted);
  };

  const dasBaseOptions = [
    { value: 'total_obra', label: 'Total da Obra' },
    { value: 'valor_a_faturar', label: 'Valor a Faturar' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-bold text-foreground mb-6">Impostos</h3>
      
      <div className="space-y-6">
        {/* DAS (Simples Nacional) */}
        <div className="space-y-4">
          <h4 className="text-base font-bold text-foreground">Imposto da nota (Simples)</h4>
          
          <Input
            label="% Efetivo do Simples"
            type="text"
            inputMode="decimal"
            placeholder="6,00"
            value={formData?.dasPercentualEfetivo}
            onChange={(e) => handleCurrencyInputChange('dasPercentualEfetivo', e?.target?.value)}
            error={errors?.dasPercentualEfetivo}
            required
            description="Alíquota efetiva do Simples"
            className="text-base"
          />
          
          <Select
            label="Calcular DAS sobre"
            options={dasBaseOptions}
            value={formData?.dasBaseCalculo}
            onChange={(value) => onChange('dasBaseCalculo', value)}
            required
            description="Base de cálculo do DAS"
          />
        </div>
        
        {/* Pró-labore (DARF) */}
        <div className="space-y-4">
          <h4 className="text-base font-bold text-foreground">Imposto do pró-labore</h4>
          
          <Input
            label="Pró-labore Mensal"
            type="text"
            inputMode="decimal"
            placeholder="0,00"
            value={formData?.prolaboreMensal}
            onChange={(e) => handleCurrencyInputChange('prolaboreMensal', e?.target?.value)}
            error={errors?.prolaboreMensal}
            required
            description="Valor mensal do pró-labore"
            className="text-base"
          />
          
          <Input
            label="INSS - Segurado (%)"
            type="text"
            inputMode="decimal"
            placeholder="11,00"
            value={formData?.inssPercentualSeg}
            onChange={(e) => handleCurrencyInputChange('inssPercentualSeg', e?.target?.value)}
            error={errors?.inssPercentualSeg}
            required
            description="Alíquota do INSS sobre pró-labore"
            className="text-base"
          />
          
          <div className="p-4 bg-muted/50 rounded-lg border border-border">
            <p className="text-sm text-muted-foreground leading-relaxed">
              <strong className="font-semibold">IRRF:</strong> Calculado automaticamente pela tabela configurável.
              Base IRRF = Pró-labore - INSS
            </p>
          </div>
        </div>
        
        {/* Observações */}
        <div>
          <label className="block text-base font-semibold text-foreground mb-3">
            Observações (Opcional)
          </label>
          <textarea
            className="w-full min-h-[100px] px-4 py-3 rounded-md border border-input bg-background text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-y"
            placeholder="Anotações sobre este cálculo..."
            value={formData?.observacoes}
            onChange={(e) => onChange('observacoes', e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default TaxSection;